import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RotaDetalhesRelatorioComponent} from '~shared/components/rota-detalhes-relatorio/rota-detalhes-relatorio.component';
import {ComponentType} from '@angular/cdk/overlay';
import {RotaDetalhesResumoComponent} from '~shared/components/rota-detalhes-resumo/rota-detalhes-resumo.component';
import {ResumoRotaComponent} from '~shared/components/resumo-rota/resumo-rota.component';
import {UrlService} from './url.service';
import { RelatoriDinamicoPdfComponent } from '~shared/components/relatorio-dinamico-dpf/relatorio-dinamico-pdf.component';
import { RelatoriDinamicoXlsComponent } from '~shared/components/relatorio-dinamico-xls/relatorio-dinamico-xls.component';

@Injectable()
export class PrintService {
  isPrinting:boolean = false;

  constructor(private router: Router, private urlService: UrlService) {
  }

  printComponent(name: PrintAlias, input?: string, data?: unknown): void {
    this.isPrinting = true;
    if (input && data) {
      localStorage.setItem(input, JSON.stringify(data));
    }
    this.router.navigate([]).then(() => {
      const url = this.urlService.routerUrl(`/(print:print/invoice/${name},${input})`);
      window.open(url, '_blank');
    });
  }

  onDataReady(): void {
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
    }, 1000);
  }

  getComponent(alias: PrintAlias): ComponentType<unknown> {
    return ComponentAlias[alias];
  }

  clearData(field: string): void {
    localStorage.removeItem(field);
  }

  getData(field: string): unknown {
    const item = localStorage.getItem(field);
    return field && item && JSON.parse(item) || undefined;
  }
}

const ComponentAlias: { [alias: string]: ComponentType<unknown> } = {
  'relatorio-rota': RotaDetalhesRelatorioComponent,
  'relatorio-custom-pdf': RelatoriDinamicoPdfComponent,
  'relatorio-custom-xls': RelatoriDinamicoXlsComponent,
  'resumo-rota-grafico': RotaDetalhesResumoComponent,
  'resumo-rota-xls': ResumoRotaComponent,
};

export declare type PrintAlias = 'relatorio-rota' | 'resumo-rota-grafico' | 'resumo-rota-xls' | 'relatorio-custom-pdf' |'relatorio-custom-xls';
